import PropTypes from 'prop-types';
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

//Import Icons
import FeatherIcon from "feather-icons-react";

// Reactstrap
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import LightDark from "../CommonForBoth/Menus/LightDark";

// import images
import logoSvg from "../../assets/images/logo.png";

//i18n
import { withTranslation } from "react-i18next";
//redux
import { useSelector, useDispatch } from "react-redux";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
  changelayoutMode
} from "../../store/actions";
import { airCargoTracking, containerTracking, growth, message_Icon, timeTracking } from '../../assets/images';
import UserGroupIconCard from '../GlobalComponent/UserGroupIconCard';

const Header = props => {
  const dispatch = useDispatch();
  const { showRightSidebar } = useSelector((state) => ({
    showRightSidebar: state.Layout.ShowRightSidebar
  }));
  const { tenant_info } = useSelector((state) => state?.settings);
  const { onChangeLayoutMode } = props;
  const [search, setsearch] = useState(false);
  const [socialDrp, setsocialDrp] = useState(false);
  const [isClick, setClick] = useState(false);

  /*** Sidebar menu icon and default menu set */
  function tToggle() {
    var body = document.body;
    setClick(!isClick);
    if (isClick === true) {
      body.classList.add("sidebar-enable");
      document.body.setAttribute('data-sidebar-size', 'sm');
    } else {
      body.classList.remove("sidebar-enable");
      document.body.setAttribute('data-sidebar-size', 'lg');
    }
  }
  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <div className="navbar-brand-box">
              <Link to="/network/dashboard" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoSvg || ""} alt="Logo" height="50" />
                </span>
                <span className="logo-lg">
                  <img src={logoSvg || ""} alt="Logo" height="50" />
                </span>
              </Link>

              <Link to="/network/dashboard" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoSvg || ""} alt="Logo" height="50" />
                </span>
                <span className="logo-lg">
                  <img src={logoSvg || ""} alt="Logo" height="50" width="64" />
                </span>
              </Link>
            </div>

            <button
              onClick={() => {
                tToggle();
              }}
              type="button" className="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn">
              <i className="fa fa-fw fa-bars"></i>
            </button>

            {/* <LanguageDropdown /> */}

          </div>

          {/* <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button type="button" className="btn header-item" id="page-header-search-dropdown"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <FeatherIcon
                  icon="search"
                  className="icon-lg"
                />
              </button>
              <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                aria-labelledby="page-header-search-dropdown">

                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input type="text" className="form-control" placeholder="Search ..." aria-label="Search Result" />

                      <button className="btn btn-primary" type="submit"><i className="mdi mdi-magnify"></i></button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div> */}
          <div className="d-flex align-items-center">
            {/* <div className="dropdown d-inline-block d-lg-none mobile_search">
              <button onClick={() => { setsearch(!search); }} type="button" className="btn header-item noti-icon common_header_btn" id="page-header-search-dropdown" >
                <FeatherIcon icon="search" className="icon-lg" />
              </button>
              <div
                className={search ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show" : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"}
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search"
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn" type="submit">
                          <FeatherIcon
                            icon="search"
                            className="icon-lg"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div> */}

            {/* <form className="app-search d-none d-lg-block">
              <div className="position-relative">
                <input type="search" className="form-control" placeholder="Search" />
                <button className="btn" type="button">
                  <FeatherIcon
                    icon="search"
                    className="icon-lg"
                  />
                  <i className="bx bx-search-alt align-middle"></i>
                </button>
              </div>
            </form> */}

            {/* light / dark mode */}
            {/* <LightDark layoutMode={props['layoutMode']} onChangeLayoutMode={onChangeLayoutMode} /> */}

            <Dropdown className="d-none d-lg-inline-block ms-1"
              isOpen={socialDrp}
              toggle={() => {
                setsocialDrp(!socialDrp);
              }}>
              <DropdownToggle
                className="btn header-item noti-icon "
                tag="button">
                <FeatherIcon
                  icon="grid"
                  className="icon-lg"
                />
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-lg dropdown-menu-end" style={{ backgroundColor: "white" }}>
                <div className="p-2">
                  <Row className="g-0">
                    <Col>
                      <Link className="dropdown-icon-item" to="/network/lead-genaration-page">
                        <UserGroupIconCard icon={growth} alt="Github" text="Marketing" />
                      </Link>
                    </Col>
                    <Col>
                      <Link className="dropdown-icon-item" to="/network/container-tracking">
                        <UserGroupIconCard icon={containerTracking} alt="bitbucket" text="Container Tracking" />
                      </Link>
                    </Col>
                  </Row>
                  <Row className="g-0">
                    <Col>
                      <Link className="dropdown-icon-item" to="/network/sailing-schedule">
                        <UserGroupIconCard icon={timeTracking} alt="dribbble" text="Shipping Schedule" />
                      </Link>
                    </Col>
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <UserGroupIconCard icon={airCargoTracking} alt="dropbox" text="Air Cargo Tracking" />
                      </Link>
                    </Col>
                  </Row>
                </div>
              </DropdownMenu>
            </Dropdown>
            {/* <button className='btn common_header_btn'>
              <img src={message_Icon} alt="Message" />
            </button> */}
            {/* <NotificationDropdown /> */}
            {/* <div onClick={() => { dispatch(showRightSidebarAction(!showRightSidebar)); }} className="dropdown d-md-inline-block d-none" >
              <button type="button" className="btn header-item noti-icon right-bar-toggle common_header_btn" >
                <FeatherIcon icon="settings" className="icon-lg" />
              </button>
            </div> */}
            <ProfileMenu />

          </div>
        </div>
      </header>

    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
  changelayoutMode: PropTypes.func,
  layoutMode: PropTypes.any,
};

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    layoutMode
  } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, layoutMode };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  changelayoutMode,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
